import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Flex, Box } from "theme-ui";
import { Label2 } from "../Text/Label2";
import { Row } from "../Layout/Responsive/Row";
import { defaultTheme } from "../../theme/theme";
import { LineHeights } from "../../theme/enums";
const { breakpoints = [] } = defaultTheme;
export const NameAndValueRow = ({ name, value }) => {
    return (_jsx(Row, { sx: { marginBottom: 0 }, children: _jsx(NameAndValueBoxes, { name: name, value: value }) }));
};
export const NameAndValueBoxes = ({ name, value }) => {
    return (_jsxs(Flex, { sx: {
            [`@media screen and (max-width: ${breakpoints[1]})`]: {
                flexDirection: "column",
                marginBottom: 8
            }
        }, children: [_jsx(Box, { sx: {
                    color: "grey.1",
                    marginRight: 8,
                    lineHeight: LineHeights.editorial,
                    [`@media screen and (max-width: ${breakpoints[1]})`]: {
                        lineHeight: 1,
                        marginRight: 0
                    }
                }, children: _jsx(Label2, { children: name }) }), _jsx(Box, { sx: { color: "grey.0" }, children: _jsx(Label2, { children: value }) })] }));
};
//# sourceMappingURL=NamesAndValues.js.map